<template>
  <div menu-alias="goods">
    <div class="container">
      <h3 v-if="mode === 'create'">
        {{ $t('goods.title.create') }}
      </h3>
      <h3 v-else>
        {{ $t('goods.title.update') }}
      </h3>
      <div class="row">
        <input style="display:none" type="text" name="faketextremembered">
        <input style="display:none" type="password" name="fakepasswordremembered">
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.thumbs"
            v-model="goods.thumbs"
            type="multifile"
            :required="true"
            :title="$t('column.nm.thumbs')"
            table-name="goods"
            :file-info="{purpose: 'file_purpose.thumb', securityType: 'file_security_type.open', usePrimary: false, accept: '.jpg,.jpeg,.gif,.bmp,.png', maxFileSize: goods.maxFileSize}"
            name="thumbs"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.nm"
            v-model="goods.nm"
            type="text"
            :title="$t('column.nm.nm')"
            name="nm"
            :required="true"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.cn"
            v-model="goods.cn"
            type="html_editor"
            :title="$t('column.nm.cn')"
            name="cn"
            :required="true"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.goodsDc"
            v-model="goods.goodsDc"
            type="html_editor"
            :title="$t('column.nm.goods_dc')"
            name="goodsDc"
            :required="true"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.compositionDc"
            v-model="goods.compositionDc"
            type="html_editor"
            :title="$t('column.nm.composition_dc')"
            name="compositionDc"
            :required="true"
          />
        </div>
        <div class="cols-xs-6 cols-sm-6 cols-md-4 cols-lg-4 cols-xl-4">
          <input-control
            ref="goodsEditForm.pc"
            v-model="goods.pc"
            type="price"
            :title="$t('column.nm.pc')"
            name="pc"
            :required="true"
          />
        </div>
        <div class="cols-xs-6 cols-sm-6 cols-md-4 cols-lg-4 cols-xl-4">
          <input-control
            ref="goodsEditForm.pc"
            v-model="goods.pcBeforeDiscount"
            type="price"
            :title="$t('column.nm.pc_before_discount')"
            name="pcBeforeDiscount"
          />
          <pig-tail-label :message="$t('column.guide.pc_before_discount')" />
        </div>
        <div class="cols-xs-6 cols-sm-6 cols-md-4 cols-lg-4 cols-xl-4">
          <input-control
            ref="goodsEditForm.currency"
            v-model="goods.currency"
            type="currency"
            :title="$t('column.nm.currency')"
            name="currency"
            :required="true"
          />
        </div>
        <div class="cols-xs-6 cols-sm-6 cols-md-6 cols-lg-6 cols-xl-6">
          <input-control
            ref="goodsEditForm.usgpdDaycnt"
            v-model="goods.usgpdDaycnt"
            type="number"
            :title="$t('column.nm.usgpd_daycnt')"
            name="usgpdDaycnt"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.intrcnVidoTyCode"
            v-model="goods.intrcnVidoTyCode"
            type="select"
            :title="$t('column.nm.intrcn_vido_ty_code')"
            :options="goods.intrcnVidoTyCodeCandidates"
            name="intrcnVidoTyCode"
            :required="true"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            v-if="goods.intrcnVidoTyCode && goods.intrcnVidoTyCode !== 'video_type.none' && goods.intrcnVidoTyCode !== 'video_type.mp4_url'"
            ref="goodsEditForm.intrcnVidoData"
            v-model="goods.intrcnVidoData"
            type-code-field-name="intrcnVidoTyCode"
            :visible-data="goods"
            type="video"
            :required="true"
            :title="$t('column.nm.intrcn_vido_data')"
            name="intrcnVidoData"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.references"
            v-model="goods.references"
            type="multifile"
            :title="$t('column.nm.references')"
            table-name="goods"
            :file-info="{purpose: 'file_purpose.reference', securityType: 'file_security_type.open', usePrimary: false, maxFileSize: goods.maxFileSize}"
            name="references"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-6 cols-lg-6 cols-xl-6">
          <input-control
            ref="goodsEditForm.ctgrys"
            v-model="goods.ctgrys"
            type="multiselect"
            :title="$t('column.nm.ctgrys')"
            :options="getSelectOptionsFromRawOptions('id', goods.ctgrysCandidates, 'multiselect')"
            :multiple="true"
            name="ctgrys"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-6 cols-lg-6 cols-xl-6">
          <input-control
            ref="goodsEditForm.channels"
            v-model="goods.channels"
            type="multiselect"
            :title="$t('column.nm.channels')"
            :options="getSelectOptionsFromRawOptions('id', goods.channelsCandidates, 'multiselect')"
            async-search-url="channel/search"
            :multiple="true"
            name="channels"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-6 cols-lg-6 cols-xl-6">
          <input-control
            ref="goodsEditForm.sellers"
            v-model="goods.sellers"
            type="multiselect"
            :title="$t('column.nm.sellers')"
            :options="getSelectOptionsFromRawOptions('id', goods.sellersCandidates, 'multiselect')"
            async-search-url="user/search"
            :multiple="true"
            name="sellers"
          />
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <div class="input-control">
            <label for="goods-composition-list">{{ $t('item.nm.goods_composition') }}</label>
            <div v-if="!goods.compositions || goods.compositions.length === 0" class="goods-composition-item no-goods-composition-item">
              {{ $t('goods.text.no_goods_composition') }}
            </div>
            <draggable id="goods-composition-list" v-model="goods.compositions" @start="drag=true" @end="drag=false">
              <div v-for="(composition, compositionIndex) in goods.compositions" :key="compositionIndex" class="goods-composition-item" :composition-index="compositionIndex">
                <div class="goods-composition-title-area">
                  {{ composition.nm }}
                </div>
                <div class="goods-composition-button-area">
                  <button v-if="!composition.showDetail" class="btn btn-default" @click="showDetail($event, composition)">
                    {{ $t('common.button.show') }}
                  </button>
                  <button v-else class="btn btn-default" @click="hideDetail($event, composition)">
                    {{ $t('common.button.hide') }}
                  </button>
                  <button class="btn btn-danger" @click="deleteCompositionConfirm($event, composition)">
                    {{ $t('common.button.delete') }}
                  </button>
                </div>
                <div class="clear" />
                <div v-show="composition.showDetail" class="row">
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      v-if="composition.showDetail"
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-thumbs'"
                      v-model="composition.thumbs"
                      :modal-name="'composition.' + compositionIndex"
                      type="multifile"
                      :title="$t('column.nm.thumbs')"
                      table-name="goods_composition"
                      :file-info="{purpose: 'file_purpose.thumb', securityType: 'file_security_type.open', usePrimary: false, accept: '.jpg,.jpeg,.gif,.bmp,.png', maxFileSize: goods.maxFileSize}"
                      name="thumbs"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-nm'"
                      v-model="composition.nm"
                      :modal-name="'composition.' + compositionIndex"
                      type="text"
                      :title="$t('column.nm.nm')"
                      name="nm"
                      :required="true"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-cn'"
                      v-model="composition.cn"
                      :modal-name="'composition.' + compositionIndex"
                      type="html_editor"
                      :title="$t('column.nm.cn')"
                      name="cn"
                      :required="true"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-4 cols-lg-4 cols-xl-4">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-optn-flag'"
                      v-model="composition.optnFlag"
                      :modal-name="'composition.' + compositionIndex"
                      type="checkbox"
                      :title="$t('column.nm.optn_flag')"
                      name="optnFlag"
                    />
                  </div>
                  <div v-if="composition.optnFlag === 'Y'" class="cols-xs-12 cols-sm-12 cols-md-4 cols-lg-4 cols-xl-4">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-adit-pc'"
                      v-model="composition.aditPc"
                      :modal-name="'composition.' + compositionIndex"
                      type="price"
                      :required="true"
                      :rules="{positive_number: true}"
                      :title="$t('column.nm.adit_pc')"
                      name="aditPc"
                    />
                  </div>
                  <div v-if="composition.optnFlag === 'Y'" class="cols-xs-6 cols-sm-6 cols-md-4 cols-lg-4 cols-xl-4">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-currency'"
                      v-model="composition.currency"
                      type="currency"
                      :title="$t('column.nm.currency')"
                      name="currency"
                      :required="true"
                    />
                  </div>
                  <div class="clear" />
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-vido-ty-code'"
                      v-model="composition.vidoTyCode"
                      :modal-name="'composition.' + compositionIndex"
                      type="select"
                      :title="$t('column.nm.vido_ty_code')"
                      :options="goods.vidoTyCodeCandidates"
                      name="vidoTyCode"
                      :required="true"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      v-if="composition.vidoTyCode && composition.vidoTyCode !== 'video_type.none' && composition.vidoTyCode !== 'video_type.mp4_url'"
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-vido-data'"
                      v-model="composition.vidoData"
                      :modal-name="'composition.' + compositionIndex"
                      type="video"
                      type-code-field-name="vidoTyCode"
                      :visible-data="composition"
                      :title="$t('column.nm.vido_data')"
                      name="vidoData"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      v-if="composition.showDetail"
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-references'"
                      v-model="composition.references"
                      :modal-name="'composition.' + compositionIndex"
                      type="multifile"
                      :title="$t('column.nm.references')"
                      table-name="goods_composition"
                      :file-info="{purpose: 'file_purpose.reference', securityType: 'file_security_type.open', usePrimary: false, maxFileSize: goods.maxFileSize}"
                      name="references"
                    />
                  </div>
                  <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
                    <input-control
                      :ref="'goodsEditForm.composition.' + compositionIndex + '-composition-sttus-code'"
                      v-model="composition.sttusCode"
                      :modal-name="'composition.' + compositionIndex"
                      type="select"
                      :title="$t('column.nm.sttus_code')"
                      :options="goods.compositionSttusCodeCandidates"
                      name="sttusCode"
                      :required="true"
                    />
                  </div>
                </div>
                <div class="clear" />
              </div>
            </draggable>
            <div class="goods-composition-create-button-area">
              <button class="btn btn-primary" @click="createComposition($event)">
                {{ $t('common.button.add_composition') }}
              </button>
            </div>
          </div>
        </div>
        <div class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12">
          <input-control
            ref="goodsEditForm.sttusCode"
            v-model="goods.sttusCode"
            type="select"
            :title="$t('column.nm.sttus_code')"
            :options="goods.sttusCodeCandidates"
            name="sttusCode"
            :required="true"
          />
        </div>
      </div>
      <div class="goods-save-button-area">
        <button class="btn btn-default" @click="cancelEditing($event)">
          {{ $t('common.button.cancel') }}
        </button>
        <button class="btn btn-primary" @click="saveGoodsConfirm($event)">
          {{ $t('common.button.save') }}
        </button>
      </div>
    </div>
    <b-modal
      id="goods-save-confirm-modal"
      ref="goodsSaveConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="saveGoods()"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
    <b-modal
      id="goods-composition-delete-confirm-modal"
      ref="goodsCompositionDeleteConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.delete')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteComposition()"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      componentId: 0,
      goods: {},
      env: process.env.env,
      isMobile: true,
      mode: 'create'
    }
  },
  created() {
    if (!window._componentId) {
      window._componentId = 0
    }
    window._componentId++
    this.componentId = window._componentId
    if (!window._processingDataCount || window._processingDataCount < 0) {
      window._processingDataCount = 0
    }
  },
  mounted() {
    if (!this.checkLogin()) {
      return
    }
    if (this.$route.query && this.$route.query.id) {
      this.mode = 'update'
    }
    this.isMobile = !!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
    $(window).bind('beforeunload', function(e) {
      return ''
    })
    this.processing = false
    this.$eventHub.$on('input-control-validated', this.onInputControlValidated)
    this.loadGoods()
  },
  beforeDestroy() {
    if (this.processing) {
      window._processingDataCount--
      this.processing = false
    }
    this.$eventHub.$off('input-control-validated', this.onInputControlValidated)
    $(window).unbind('beforeunload')
  },
  methods: {
    onInputControlValidated() {
      this.validatedCount++
    },
    onForceUpdate() {
      this.$forceUpdate()
    },
    async saveGoodsConfirm(e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }

      if (this.$refs['goodsEditForm.references'].isUploading()) {
        this.$toast.error(this.$t('common.text.uploading'))
        return
      }
      const goods = this.goods
      if (goods.compositions && goods.compositions.length > 0) {
        for (let i = 0; i < goods.compositions.length; i++) {
          const composition = goods.compositions[i]
          composition.showDetail = false
        }
      }
      this.validatedCount = 0
      if (await this.validateUnder(this.$el)) {
        this.showModal('goodsSaveConfirmModalRef')
      }
    },
    getOut(id) {
      if (
        this.$router.previousPath &&
        this.$router.previousPath !== this.$route.path
      ) {
        let url = this.$router.previousPath
        if (this.$router.previousQuery) {
          for (const key in this.$router.previousQuery) {
            if (url.indexOf('?') >= 0) {
              url += '&'
            } else {
              url += '?'
            }
            url += key + '=' + this.$router.previousQuery[key]
          }
        }
        this.$router.push(url)
      } else if (id) {
        this.$router.push('/goods?id=' + id)
      } else {
        this.$router.push('/')
      }
    },
    cancelEditing() {
      this.getOut(this.goods.id)
    },
    saveGoods() {
      this.$axios.$post('/goods/saveGoods', this.goods).then(response => {
        if (response.resultCode === 'success') {
          window._processingDataCount = 0
          this.processing = false
          this.$toast.info(this.$t(response.message))
          this.getOut(response.data.id)
        } else if (response.message) {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        } else {
          console.error('Cannot load offer metas.')
          this.$toast.error('Cannot load offer metas.')
        }
      })
    },
    createComposition(e) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      const newComposition = {
        sttusCode: 'composition_status.active',
        vidoTyCode: 'video_type.none',
        compositionTyCode: 'composition_type.online_contents_video',
        optnFlag: 'N',
        currency: 'KRW'
      }
      if (this.configs.only_for_korea_republic_of !== 'true') {
        newComposition.currency = 'USD'
      }
      this.goods.compositions.push(newComposition)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    showDetail(e, composition) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      composition.showDetail = true
      this.$forceUpdate()
    },
    hideDetail(e, composition) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      composition.showDetail = false
      this.$forceUpdate()
    },
    deleteCompositionConfirm(e, composition) {
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      this.targetComposition = composition
      this.showModal('goodsCompositionDeleteConfirmModalRef')
    },
    deleteComposition() {
      const composition = this.targetComposition
      for (let i = 0; i < this.goods.compositions.length; i++) {
        if (this.goods.compositions[i] === composition) {
          this.goods.compositions.splice(i, 1)
          break
        }
      }
    },
    loadGoods() {
      let url
      if (this.mode === 'update') {
        url = '/goods/goodsDetailForUpdate?id=' + this.$route.query.id
      } else {
        url = '/goods/goodsInfoForInsert'
      }
      this.$axios
        .$get(url)
        .then(response => {
          if (response.resultCode === 'success') {
            this.goods = response.data
            if (this.mode !== 'update') {
              this.goods.currency = 'KRW'
              if (this.configs.only_for_korea_republic_of !== 'true') {
                this.goods.currency = 'USD'
              }
            }
            if (this.goods.ctgrys && this.goods.ctgrys.length > 0) {
              const ctgrys = []
              for (let i = 0; i < this.goods.ctgrys.length; i++) {
                if (
                  this.goods.ctgrysCandidates &&
                  this.goods.ctgrysCandidates.length > 0
                ) {
                  for (let j = 0; j < this.goods.ctgrysCandidates.length; j++) {
                    if (
                      parseInt(this.goods.ctgrys[i].id) ===
                      parseInt(this.goods.ctgrysCandidates[j].value)
                    ) {
                      this.goods.ctgrysCandidates[j].text = this.$t(
                        'ctgry.nm.homepage.' + this.goods.ctgrys[i].id
                      )
                      ctgrys.push(this.goods.ctgrysCandidates[j])
                      break
                    }
                  }
                }
              }
              this.goods.ctgrys = ctgrys
            }
            this.$forceUpdate()
            this.processing = true
            this.$nextTick(() => {
              $(this.$el)
                .find('[name=nm]')
                .focus()
            })
            window._processingDataCount++
            this.$eventHub.$emit('content-loaded')
          } else if (response.message) {
            this.$eventHub.$emit('content-loaded')
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
            this.$router.push('/')
          } else {
            this.$eventHub.$emit('content-loaded')
            console.error('Cannot load order metas.')
            this.$toast.error('Cannot load order metas.')
            this.$router.push('/')
          }
        })
        .catch(() => {
          this.$eventHub.$emit('content-loaded')
          this.$router.push('/')
        })
    }
  }
}
</script>

<style scoped>
.input-control {
  margin-bottom: 20px;
}
.goods-save-button-area {
  text-align: right;
  padding: 10px 0;
}
.goods-composition-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.goods-composition-item {
  cursor: move;
  padding: 10px;
  margin-bottom: -1px;
  border: 1px solid #cccccc;
}
.goods-composition-item:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 0;
}
.no-goods-composition-item {
  border-radius: 10px;
  cursor: auto;
}
.goods-composition-create-button-area {
  width: 100%;
  text-align: right;
  padding: 10px 0;
}
.goods-composition-title-area {
  float: left;
  width: 80%;
  padding: 6px 0;
}
.goods-composition-button-area {
  float: right;
  text-align: right;
  width: 20%;
}
</style>
